// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","switcher":"switcher-jitr1","switcher_alternative":"switcher_alternative-1diwZ"};